import { IApprovedEnBlocBidder } from "../parcel/IBidder";
import { IParcelBidDict } from "../parcel/IParcelBid";
import { IParcelBidLog } from "../parcel/IParcelBidLog";

export enum AuctionStatus {
    New = "New",
    Live = "Live",
    Completed = "Completed"
}

export default interface IAuctionStatus {
    auctionId: string;
    parcelId: string;
    checkOutToken: string;
    isActive: boolean;
    parcelStartDate: string;
    parcelEndDate: string;
    bids: IParcelBidDict;
    status: AuctionStatus;
    updateMessage: string;
    approvedEnBlocBidders: IApprovedEnBlocBidder[];
    bidLogs: IParcelBidLog[];
}
